import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";

const StepFive = forwardRef(({ formData, setFormData }, ref) => {
  const [errors, setErrors] = useState({});

  const validateField = (label, value) => {
    if (!value?.trim()) return ""; // Field is optional, empty is valid

    if (value.length < 10) {
      return `${label} must be at least 10 characters if provided.`;
    }

    if (value.length > 1000) {
      return `${label} cannot exceed 1000 characters.`;
    }

    return "";
  };

  const validateAllFields = () => {
    const welcomeError = validateField("Welcome Message", formData.welcomeMessage);
    const congratsError = validateField("Congratulations Message", formData.congratulationsMessage);

    const newErrors = {
      welcomeMessage: welcomeError,
      congratulationsMessage: congratsError,
    };

    setErrors(newErrors);

    return !welcomeError && !congratsError;
  };

  useImperativeHandle(ref, () => ({
    validate: validateAllFields,
  }));

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    // Live validation
    const label = field === "welcomeMessage" ? "Welcome Message" : "Congratulations Message";
    const errorMsg = validateField(label, value);

    setErrors((prev) => ({ ...prev, [field]: errorMsg }));
  };

  useEffect(() => {
    if (
      formData.welcomeMessage &&
      errors.welcomeMessage &&
      !validateField("Welcome Message", formData.welcomeMessage)
    ) {
      setErrors((prev) => ({ ...prev, welcomeMessage: null }));
    }

    if (
      formData.congratulationsMessage &&
      errors.congratulationsMessage &&
      !validateField("Congratulations Message", formData.congratulationsMessage)
    ) {
      setErrors((prev) => ({ ...prev, congratulationsMessage: null }));
    }
  }, [formData.welcomeMessage, formData.congratulationsMessage]);

  return (
    <div className="card-default-style step-form-holder">
      <div className="step-form-holder-inner mx-auto my-10 my-lg-17">
        <div className="mb-10 mb-sm-20 mb-md-32">
          <h2 className="ah-heading-04 fw-bold text-black mb-10">Course Messages</h2>
          <p className="ah-text-sm fw-semibold mb-0">
            Write messages to your students (optional) that will be sent
            automatically when they join or complete your course to engage
            students with course content. If you do not wish to send a welcome
            or congratulations message, leave the text box blank.
          </p>
        </div>

        <div className="card-default-style py-lg-36 px-lg-30 py-xl-42 px-xl-36">
          <div className="form-group mb-16 mb-md-24">
            <label className="form-label fw-semibold mb-8 mb-lg-12">Welcome Message</label>
            <textarea
              className="form-control mb-12"
              rows="4"
              placeholder="Write your welcome message here..."
              value={formData.welcomeMessage || ""}
              onChange={(e) => handleInputChange("welcomeMessage", e.target.value)}
            />
            {errors.welcomeMessage && (
              <div className="text-danger mb-10 fw-semibold">{errors.welcomeMessage}</div>
            )}
          </div>

          <div className="form-group mb-16 mb-md-24">
            <label className="form-label fw-semibold mb-8 mb-lg-12">Congratulations Message</label>
            <textarea
              className="form-control mb-12"
              rows="4"
              placeholder="Write your congratulations message here..."
              value={formData.congratulationsMessage || ""}
              onChange={(e) => handleInputChange("congratulationsMessage", e.target.value)}
            />
            {errors.congratulationsMessage && (
              <div className="text-danger mb-10 fw-semibold">{errors.congratulationsMessage}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default StepFive;
